import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Prompt } from "react-router"
import { routerMiddleware, push } from 'react-router-redux'
import {CopyToClipboard} from 'react-copy-to-clipboard'
import Dropdown from 'react-dropdown'
import shortid from 'shortid'
import Hashids from 'hashids'

import 'react-dropdown/style.css'

import {
  ReflexContainer,
  ReflexSplitter,
  ReflexElement
} from 'react-reflex'

import 'react-reflex/styles.css'
import 'react-dropdown/style.css'

import parseText from '../pattern_utilities/parseText'
import generateName from '../pattern_utilities/generateName'
import { 
  pmUpdateFromText,
  pmUpdateFromHybrid,
  tryToLoadPattern,
  tryToGetMyPatterns,
  tryToGetTeamPatterns,
  tryToGetOfficialPatterns,
  tryToFetchMyAccountInfo,
  tryToFetchMyTeams,
  tryToFetchMyPendingInvites,
  pmSetCurrentPattern,
  toggleLights,
  setGridMode,
  setTrayOpen,
  setMobilePreview,
  setFullScreen,
  setDisplayZoomControls,
  showTooltip,
  hideTooltip,
  setAutoSave,
  setRecentPatterns,
  setCurrentTeam,
  unsetCurrentTeam,
  newDrawingPattern,
  newBlankPattern,
  setTemplateModalOpen,
  setDXFGeneratorOpen,
  uploadPATFile,
  setJDISettingsModalOpen,
  hideLockedFeatureModal
} from '../actions/actions.export.js'

import Pattern from '../components/Pattern/Pattern.js';
import PatternThumbnail from '../components/PatternThumbnail/PatternThumbnail.js'
import TextEditor from '../components/TextEditor/TextEditor.js'
import JustDrawIt from '../components/JustDrawIt/JustDrawIt.js'
import SuperEditor from '../components/SuperEditor/SuperEditor.js'
import CalculatorEditor from '../components/CalculatorEditor/CalculatorEditor.js'
import Tabs from '../components/Tabs/Tabs.js'
import Button from '../components/Button/Button.js'
import OriginSelector from '../components/OriginSelector/OriginSelector.js'

import ToolHeader from '../components/ToolHeader/ToolHeader.js'
import ToolFooter from '../components/ToolFooter/ToolFooter.js'
import ToolLibraryTray from '../components/ToolTrays/ToolLibraryTray.js'
import ToolCalculatorTray from '../components/ToolTrays/ToolCalculatorTray.js'
import ToolSavedTray from '../components/ToolTrays/ToolSavedTray.js'
import ToolLeftMenu from '../components/ToolLeftMenu/ToolLeftMenu.js'

import DXFGenerator from '../components/DXFGenerator/DXFGenerator.js'
import LoginModal from '../components/LoginModal/LoginModal.js'
import TemplateModal from '../components/TemplateModal/TemplateModal.js'
import LockedFeatureModal from '../components/LockedFeatureModal/LockedFeatureModal.js'
import ScaleModal from '../components/ScaleModal/ScaleModal.js'
import RotateModal from '../components/RotateModal/RotateModal.js'
import DownloadModal from '../components/DownloadModal/DownloadModal.js'
import ImageExportModal from '../components/ImageExportModal/ImageExportModal.js'
import ConfirmExitModal from '../components/ConfirmExitModal/ConfirmExitModal.js'
import JDISettingsModal from '../components/JDISettingsModal/JDISettingsModal.js'

import canI from '../canI.js';

var pf_config = require('../pf_config.json');

var hashids = new Hashids('k100p');


class Tool extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      resizeCounter: 0,
      jdiTool: 'Pen'
    }

    this.incrementResize = this.incrementResize.bind(this);
    this.handleDownloadPNG = this.handleDownloadPNG.bind(this);
    this.handleAddRow = this.handleAddRow.bind(this);
    this.handleLoadPatFile = this.handleLoadPatFile.bind(this);
  }

  incrementResize(){
    let r = this.state.resizeCounter;
    this.setState({
      resizeCounter: r + 1
    })
  }

  handleAddRow(){
    const { dispatch, patternManager } = this.props; 
    let pat = patternManager.cache[patternManager.current_pattern];
    pat.rows.push({
      original_index: pat.rows.length,
      cells: [0, 0, 0, 1, 1, 1, -1]
    });
    dispatch(pmUpdateFromHybrid({
      pattern: pat,
      cacheID: patternManager.current_pattern,
      regenText: true
    }))
  }

  handleLoadPatFile(e){
    const { dispatch, patternManager } = this.props;

    var file = document.getElementById('input-pattern').files[0];
    
    dispatch(uploadPATFile({
      file: file,
      cacheID: 'local'
    }));
    dispatch(pmSetCurrentPattern({cacheID: 'local'}));
  }

  handleDownloadPNG(canvid){
    const { patternManager } = this.props;

    var canvas = document.getElementById("pat-" + canvid);
    var image = canvas.toDataURL();

    var aLink = document.createElement('a');
    aLink.download = generateName(patternManager.cache[patternManager.current_pattern]) + '.png';
    aLink.href = image;
    aLink.click();
    aLink.remove();
  }

  componentWillMount(){
    const { dispatch, patternManager, globalReducer, user, team } = this.props;

    if(user.isLoggedIn){
      dispatch(tryToFetchMyPendingInvites());
    }

    
    if(user.roles.enterprise){
      if(user.teams.length == 1){
        dispatch(setCurrentTeam(user.teams[0]));
        dispatch(tryToGetTeamPatterns({
          id: user.teams[0]
        }))
      }
    }
    if(user.settings.workspace){
      if(user.settings.workspace == "me"){
        dispatch(unsetCurrentTeam())
      } else {
        dispatch(setCurrentTeam(user.settings.workspace));
      }
    }

    var mobileCheck = function() {
      var check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    };

    if(mobileCheck()){
      dispatch(setMobilePreview(true));
    }
  }

  componentWillReceiveProps(newprops){
    const { dispatch, team, patternManager, user } = this.props;
    
    var pattern = patternManager.cache[patternManager.current_pattern];
    window.document.title = generateName(pattern) + ' - Pattycake';
    var line_limit = canI(user, team, 'jdi_line_limit', team.current);
    
    var tool = 'Pen';
    if(pattern.lineSegments.length >= canI(user, team, 'jdi_line_limit', team.current)){
      this.setState({
        jdiTool: 'Pointer'
      })
    }

    this.setState({
      colLeft: newprops.patternManager.quad1 || '.PAT Text',
      colRight: newprops.patternManager.quad4 || '.PAT Preview',
      quad1: newprops.patternManager.quad1 || 'Hybrid Editor',
      quad2: newprops.patternManager.quad2 || '.PAT Text',
      quad3: newprops.patternManager.quad3 || 'Calculator',
      quad4: newprops.patternManager.quad4 || '.PAT Preview',
    })
  

    if(pattern){
      if(pattern.private){
        if(team.current && team.cache[team.current]){
          if(pattern.scope !== team.cache[team.current].id){
            // console.error("WE SHOULDNT SEE THIS ITS MY TEAMS NOT MINE!");
          }
        }
        if(!team.current && pattern.scope !== user.id){
          // console.error("THIS BELONGS TO A TEAM AND I'M ACTING AS ME!");
        }
      }
    }



    var pattern_hash_id = newprops.match.params.pattern_hash_id;
    var encoded_pattern = window.location.hash.replace('#','');
    if(pattern_hash_id){
      if(this.state.pattern_hash_id != pattern_hash_id){
        this.setState({
          pattern_hash_id: pattern_hash_id
        })
        dispatch(setTrayOpen({tray: "saved", open: false}));
        dispatch(setTrayOpen({tray: "library", open: false}));
        return dispatch(tryToLoadPattern({id: pattern_hash_id, setCurrent: true}));
      }
    } else if(encoded_pattern.length > 1){
      var data = JSON.parse(window.atob(decodeURIComponent(encoded_pattern)));
      dispatch(push('/new'));
      setTimeout((e)=>{
        dispatch(pmUpdateFromText({
          cacheID: 'local',
          pattern: parseText(data.text)
        }));
        dispatch(setTrayOpen({tray: "saved", open: false}));
        dispatch(setTrayOpen({tray: "library", open: false}));
      });
      return;
    }
    
    
    if((this.props.location.pathname != newprops.location.pathname || patternManager.leftAt != newprops.patternManager.leftAt) || (this.props.location.pathname != newprops.location.pathname && !newprops.patternManager.leftAt)){
      let pieces = newprops.location.pathname.split('/');  

      dispatch(setTrayOpen({tray: "library", open: false}));
      dispatch(setTrayOpen({tray: "saved", open: false}));
      
      if(pieces[pieces.length - 1] === 'new'){
        this.setState({ 
          pattern_hash_id: ""
        });
        return dispatch(newBlankPattern(user.settings));
      }

      if(pieces[pieces.length - 1] === 'drawing' && pieces[pieces.length - 2] === 'new'){
        this.setState({ pattern_hash_id: "" });
        return dispatch(newDrawingPattern(user.settings));
      }

      if(pieces[pieces.length - 1] === 'template' && pieces[pieces.length - 2] === 'new'){
        this.setState({ pattern_hash_id: "" });
        // return dispatch(setTemplateModalOpen(true));
        return dispatch(setTrayOpen({
          tray: 'calculators',
          open: true
        }))
      }

      if(pieces[pieces.length - 1] === 'dxf' && pieces[pieces.length - 2] === 'new'){
        this.setState({ pattern_hash_id: "" });
        dispatch(newDrawingPattern(user.settings));
        setTimeout((e)=>{
          dispatch(push(newprops.location.pathname.replace('dxf','drawing')));
          dispatch(setDXFGeneratorOpen(true));
        })
      }

      if(pieces[pieces.length - 1] === 'import' && pieces[pieces.length - 2] === 'new'){
        this.setState({ pattern_hash_id: "" });
        dispatch(newBlankPattern(user.settings));
        dispatch(push(newprops.location.pathname.replace('/new/import','/new/imported')));
        setTimeout((e)=>{
          document.getElementById('input-pattern').click();  
        }, 1000)
      }
    }


    if(team.current && team.cache[team.current]){
      if(team.cache[team.current].admin_only){
        dispatch(push('/settings/firm/' + hashids.encode(team.cache[team.current].id) + '/members/access'))
      }
    }
  }

  componentDidMount(){
    const { dispatch, patternManager, globalReducer, user, team } = this.props;


    if(!user.isLoggedIn){
      if(!globalReducer.lights) dispatch(toggleLights());
    } else {
      dispatch(tryToGetMyPatterns());
      dispatch(tryToFetchMyAccountInfo());
      dispatch(tryToFetchMyTeams());
      if(team.current){
        dispatch(tryToGetTeamPatterns({
          id: team.current
        }))
      }
    }

    dispatch(tryToGetOfficialPatterns());
    dispatch(setTrayOpen(false));
    dispatch(hideLockedFeatureModal());

    

    var pattern_hash_id = this.props.match.params.pattern_hash_id;
    var encoded_pattern = window.location.hash.replace('#','');
    if(pattern_hash_id){
      dispatch(setTrayOpen({tray: "saved", open: false}));
      dispatch(setTrayOpen({tray: "library", open: false}));
      return dispatch(tryToLoadPattern({id: pattern_hash_id, setCurrent: true}));
    } else if(encoded_pattern.length > 1){
      var data = JSON.parse(window.atob(decodeURIComponent(encoded_pattern)));
      dispatch(push('/new'));
      setTimeout((e)=>{
        dispatch(pmUpdateFromText({
          cacheID: 'local',
          pattern: parseText(data.text)
        }));
        dispatch(setTrayOpen({tray: "saved", open: false}));
        dispatch(setTrayOpen({tray: "library", open: false}));
      });
      return;
    } 

    
    let pieces = window.location.pathname.split('/');

    if(pieces[pieces.length - 1] === 'new'){
      return dispatch(newBlankPattern(user.settings));
    }

    if(pieces[pieces.length - 1] === 'drawing' && pieces[pieces.length - 2] === 'new'){
      return dispatch(newDrawingPattern(user.settings));
    }

    if(pieces[pieces.length - 1] === 'template' && pieces[pieces.length - 2] === 'new'){
      // dispatch(push('/pat'));
      // return dispatch(setTemplateModalOpen(true));
      return dispatch(setTrayOpen({
          tray: 'calculators',
          open: true
        }))
    }

    if(pieces[pieces.length - 1] === 'dxf' && pieces[pieces.length - 2] === 'new'){
      
      dispatch(push('/new/drawing'));
      return dispatch(setDXFGeneratorOpen(true));
    }

    if(pieces[pieces.length - 1] === 'import' && pieces[pieces.length - 2] === 'new'){
      return dispatch(push('/new/drawing'));
    }

    if(pieces[pieces.length - 1] === 'imported' && pieces[pieces.length - 2] === 'new'){
      return dispatch(push('/new/drawing')); 
    }


    return dispatch(newDrawingPattern(user.settings));
    
    window.addEventListener('resize', this.incrementResize);
  }

  render(){
    const { dispatch, patternManager, globalReducer, user, team } = this.props;  
    var pattern = patternManager.cache[patternManager.current_pattern];

    if(!pattern.mode) pattern.mode = 'raster';
    if(!pattern.lineSegments) pattern.lineSegments = [];


    if(globalReducer.mobilePreview){
      return <div className="full-container">
        <Pattern 
          hideGUI={true}
          light={true} 
          thumbnail={true}
          cacheID={patternManager.current_pattern} 
          pattern={patternManager.cache[patternManager.current_pattern]} 
          resize={this.state.resizeCounter}
          />

        <div className="mobile-preview-overlay">
          <Link to="/" className="brand-font">
            <span className="brand-space-fix">P</span>attycake
          </Link>
          {/*<img src={patternManager.cache[patternManager.current_pattern].thumbnailDataUrl} className="mobile-preview-image"/>*/}
          <div className="foot">
            {
              this.props.match.params.pattern_hash_id ? 
                <span>To edit this pattern, visit this link on a desktop browser.</span>
                :
                <span>Looking for the best free .pat editor out there?<br/>Visit this link on a desktop browser.</span>
            }
          </div>
        </div>
      </div>
    }

    var data = {
      text: pattern.text
    };

    var shareURL = window.location.origin + '/pat/#' + encodeURIComponent(window.btoa(JSON.stringify(data)));


    var decimal_places = pattern.decimal_places;
    if(decimal_places === undefined) decimal_places = 8;

    var textPaneLinks = <span className="pane-links">
        {
          pattern.mode !== 'raster' && <span>
            <span 
              className="pane-link text-warning" 
              onClick={(e)=>{ 
                dispatch(pmUpdateFromHybrid({
                  cacheID: patternManager.current_pattern, 
                  pattern: {
                    mode: 'raster' 
                  }
                })); 
              }} 
              >
              Bake pattern to make manual changes.&nbsp;
            </span> <span
              className="has-tooltip"
              onMouseEnter={(e)=>{ 
                dispatch(showTooltip({
                  e: e,
                  position: 'left', 
                  lag: 100,
                  nobr: false,
                  content: <div style={{width: 200}}>
                    Baking a pattern finalizes the drawing or template data, allowing you to make manual changes to the raw .PAT file.
                  </div>
                }))
              }} 
              onMouseLeave={(e)=>{ dispatch(hideTooltip()) }}
              >
              <i className="fal fa-question-circle text-grey-primary"/>&nbsp;
            </span>
          </span>  
        }
      </span>

    var textPaneContent = <div className="pane-content">
      <SuperEditor cacheID={patternManager.current_pattern} />
    </div>


    const patternPaneContent = (canvid) =>{
      return <div className="pane-content">
          <Pattern 
            id={shortid.generate() + '-' + canvid} 
            cacheID={patternManager.current_pattern} 
            pattern={patternManager.cache[patternManager.current_pattern]} 
            resize={this.state.resizeCounter}
            rulers={globalReducer.rulers}
            errors={globalReducer.errors}
            gui={globalReducer.gridLines}
            colors={globalReducer.colors}
            light={(globalReducer.lights || !canI(user, team, 'nightmode', team.current))}
            zoomSlider={globalReducer.zoomControls}
            />
        </div>
      }

    var hybridPaneLinks = <span className="pane-links"></span>

    var hybridPaneContent = <div className="pane-content">
        <SuperEditor cacheID={patternManager.current_pattern} />
      </div>


    var calculatorPaneLinks = <span className="pane-links"></span>

    var calculatorPaneContent = <div className="pane-content overflow-y-auto">
        <CalculatorEditor cacheID={patternManager.current_pattern} />
      </div>


    var recentPatterns = JSON.parse(JSON.stringify(patternManager.myPatterns || []));
    if(team.current && team.cache[team.current]){
      recentPatterns = patternManager.teamPatterns[team.cache[team.current].id] || [];
    }

    recentPatterns.sort(function(a,b){
      if(patternManager.cache[a].updated_on > patternManager.cache[b].updated_on) return -1;
      if(patternManager.cache[a].updated_on < patternManager.cache[b].updated_on) return 1;
      return 0;
    });

    var recentPatternsPaneContent = <div className="pane-content overflow-y-auto recent-patterns">
      {
        recentPatterns.map(function(p, i){
          return <div key={i} className="recent-pattern-wrapper">
            <PatternThumbnail 
              cacheID={p} 
              light={true} 
              onClick={(e)=> { dispatch(setTrayOpen(false)) }} 
              icons={false} 
              tiny={true}
              />
          </div>
        })
      }  
    </div>


    var jdiLinks = <span className="pane-links">
      <span 
        className={"pane-link " + (this.state.jdiTool === 'Pointer' ? "pane-link-toggled-on" : "" )}
        onMouseEnter={(e)=>{ dispatch(showTooltip({lag: 150, e: e, position: 'top', content: 'Pointer' })) }} 
        onMouseLeave={(e)=>{ dispatch(hideTooltip()) }}
        onClick={(e) => { this.setState({jdiTool: 'Pointer'}) }}>
        {
          this.state.jdiTool === 'Pointer' ?
          <i className="pane-link-icon fas fa-lg fa-fw fa-mouse-pointer"/>
          :
          <i className="pane-link-icon fal fa-lg fa-fw fa-mouse-pointer"/>
        }
      </span>
      <span 
        className={"pane-link " + (this.state.jdiTool === 'Pen' ? "pane-link-toggled-on" : "" ) + (pattern.lineSegments.length >= canI(user, team, 'jdi_line_limit', team.current) ? " pane-link-disabled" : "")}
        onMouseEnter={(e)=>{ 
          var line_limit = canI(user, team, 'jdi_line_limit', team.current);
          var display = 'Pencil';
          if(pattern.lineSegments.length >= line_limit){
            if(user.isLoggedIn){
              display = <span>Upgrade to Pro or create a team to draw unlimited lines <i className="fad fa-award text-award"/></span>
            } else {
              display = <span>Create a free account to draw more lines <i className="fad fa-award text-award"/></span>
            }
          }
          
          dispatch(showTooltip({
            lag: 150, 
            e: e, 
            position: 'top', 
            content: display
          })) 
        }} 
        onMouseLeave={(e)=>{ dispatch(hideTooltip()) }}
        onClick={(e) => { 
          var line_limit = canI(user, team, 'jdi_line_limit', team.current);
          if(pattern.lineSegments.length >= line_limit) return;

          this.setState({jdiTool: 'Pen'}) 
        }}>
        {
          this.state.jdiTool === 'Pen' ?
          <i className="pane-link-icon fas fa-lg fa-fw fa-pencil"/>
          :
          <i className="pane-link-icon fal fa-lg fa-fw fa-pencil"/>
        }
      </span>
      <span 
        className={"pane-link " + (this.state.jdiTool === 'Continuous Pen' ? "pane-link-toggled-on" : "" ) + (canI(user, team, 'polyline', team.current) ? "" : " pane-link-disabled")}
        onMouseEnter={(e)=>{ 
          dispatch(showTooltip({
            lag: 150, 
            e: e, 
            position: 'top', 
            content: <span>Polyline {!canI(user, team, 'polyline', team.current) && <i className="fad fa-award text-award"/>}</span>
          })) 
        }} 
        onMouseLeave={(e)=>{ dispatch(hideTooltip()) }}
        onClick={(e) => { 
            if(canI(user, team, 'polyline', team.current)) this.setState({jdiTool: 'Continuous Pen'}) 
        }}>
        <i className="pane-link-icon fas fa-lg fa-fw fa-wave-triangle"/>
      </span>
      <span 
        className={"pane-link " + (this.state.jdiTool === 'Spline' ? "pane-link-toggled-on" : "" ) + (canI(user, team, 'spline', team.current) ? "" : " pane-link-disabled")}
        onMouseEnter={(e)=>{ 
          dispatch(showTooltip({
            lag: 150, 
            e: e, 
            position: 'top', 
            content: <span>Spline {!canI(user, team, 'spline', team.current) && <i className="fad fa-award text-award"/>}</span>
          })) 
        }} 
        onMouseLeave={(e)=>{ dispatch(hideTooltip()) }}
        onClick={(e) => { 
          if(canI(user, team, 'spline', team.current)) this.setState({jdiTool: 'Spline'}) 
        }}>
        {
          this.state.jdiTool === 'Spline' ?
          <i className="pane-link-icon fas fa-lg fa-fw fa-wave-sine"/>
          :
          <i className="pane-link-icon fal fa-lg fa-fw fa-wave-sine"/>
        }
      </span>

      <span 
        className={"pane-link " + (this.state.jdiTool === 'Circle' ? "pane-link-toggled-on" : "" ) + (canI(user, team, 'circle', team.current) ? "" : " pane-link-disabled")}
        onMouseEnter={(e)=>{ 
          dispatch(showTooltip({
            lag: 150, 
            e: e, 
            position: 'top', 
            content: <span>Polygon {!canI(user, team, 'circle', team.current) && <i className="fad fa-award text-award"/>}</span>
          })) 
        }} 
        onMouseLeave={(e)=>{ dispatch(hideTooltip()) }}
        onClick={(e) => { 
          if(canI(user, team, 'circle', team.current)) this.setState({jdiTool: 'Circle'}) 
        }}>
        {
          this.state.jdiTool === 'Circle' ?
          <i className="pane-link-icon fas fa-lg fa-fw fa-draw-circle"/>
          :
          <i className="pane-link-icon fal fa-lg fa-fw fa-draw-circle"/>
        }
      </span>


      <span 
        className={"pane-link " + (this.state.jdiTool === 'Trim' ? "pane-link-toggled-on" : "" ) + (canI(user, team, 'trim', team.current) ? "" : " pane-link-disabled")}
        onMouseEnter={(e)=>{ 
          dispatch(showTooltip({
            lag: 150, 
            e: e, 
            position: 'top', 
            content: <span>Trim {!canI(user, team, 'trim', team.current) && <i className="fad fa-award text-award"/>}</span>
          })) 
        }} 
        onMouseLeave={(e)=>{ dispatch(hideTooltip()) }}
        onClick={(e) => { 
          if(canI(user, team, 'trim', team.current)) this.setState({jdiTool: 'Trim'}) 
        }}>
        {
          this.state.jdiTool === 'Trim' ?
          <i className="pane-link-icon fas fa-lg fa-fw fa-cut"/>
          :
          <i className="pane-link-icon fal fa-lg fa-fw fa-cut"/>
        }
        
      </span>
    </span>

    var jdiContent = <div className="pane-content">
      <JustDrawIt 
        tool={this.state.jdiTool} 
        cacheID={patternManager.current_pattern} 
        pattern={patternManager.cache[patternManager.current_pattern]} 
        resize={this.state.resizeCounter}
        />
    </div>


    if(globalReducer.fullScreen){
      return <div className={"content-wrapper " + ((globalReducer.lights || (!canI(user, team, 'nightmode', team.current))) ? 'theme-light' : 'theme-dark')}>
        <div className="pane">
          <div className="pane-header">
            <span className="pane-title">
              <span>{generateName(patternManager.cache[patternManager.current_pattern])}</span>
            </span>
            <span className="pane-links">
              <span 
                className={"pane-link"}
                onClick={(e) => { dispatch(setFullScreen(false)) }}>
                <i className="pane-link-icon fal fa-lg fa-fw fa-compress-wide"/>
              </span>
            </span>
          </div>
          {patternPaneContent('fullScreen')}
        </div>
      </div>
    }


    const editorPane = paneName => {
      return <div className="pane">
        <div className="pane-header">
          <span className="pane-name">
            { paneName }
          </span>
          { paneName === '.PAT Text' && textPaneLinks }
          { paneName === 'Hybrid Editor' && hybridPaneLinks }
          { paneName === 'Template' && calculatorPaneLinks }
          { paneName === 'Drawing Canvas' && jdiLinks }
        </div>
          { paneName === '.PAT Text' && textPaneContent }
          { paneName === 'Hybrid Editor' && hybridPaneContent }
          { paneName === 'Template' && calculatorPaneContent }
          { paneName === 'Drawing Canvas' && jdiContent }
      </div>
    }

    const renderPane = paneName => {
      return <div className="pane">
        <div className="pane-header">
          <span className="pane-name">{ paneName }</span>
          { paneName === '.PAT Text' && textPaneLinks }
          { paneName === 'Hybrid Editor' && hybridPaneLinks }
          { paneName === 'Template' && calculatorPaneLinks }
          { paneName === 'Drawing Canvas' && jdiLinks }
        </div>
          { paneName === '.PAT Text' && textPaneContent }
          { paneName === 'Hybrid Editor' && hybridPaneContent }
          { paneName === 'Template' && calculatorPaneContent }
          { paneName === '.PAT Preview' && patternPaneContent(paneName) }
          { paneName === 'Drawing Canvas' && jdiContent }
      </div>
    }

    let theme = undefined;
    if(team.current && team.cache[team.current]){
      theme = team.cache[team.current].theme;
    }

    return <div className={"content-wrapper " +  ((globalReducer.lights || !canI(user, team, 'nightmode', team.current)) ? 'theme-light' : 'theme-dark')}>
      {
        (patternManager.tryingToLoadPattern || team.tryingToFetchMyTeams || user.tryingToFetchMyAccountInfo) && <div className="dead-center dead-center-themed" style={{
          background: theme ? theme : undefined
        }}>
          <i className="fas fa-spinner-third fa-spin fa-3x"/>
        </div>
      }
      <div className="home">
        <ToolLeftMenu cacheID={patternManager.current_pattern} />
        <div>
        <ToolLibraryTray/>
        <ToolCalculatorTray/>
        <ToolSavedTray/>
        </div>
        { globalReducer.dxfGeneratorOpen && <DXFGenerator/> }
        { !user.isLoggedIn && <LoginModal/> }
        { globalReducer.lockedFeatureModal.open && <LockedFeatureModal/> }
        { globalReducer.scaleModalOpen && <ScaleModal cacheID={patternManager.current_pattern}/> }
        { globalReducer.rotateModalOpen && <RotateModal cacheID={patternManager.current_pattern}/> }
        { globalReducer.downloadModalOpen && <DownloadModal/> }
        { globalReducer.imageExportModalOpen && <ImageExportModal/> }
        { globalReducer.jdiSettingsModalOpen && <JDISettingsModal/> }
        <ConfirmExitModal when={(pattern.unsavedChanges || patternManager.tryingToUpdatePattern || patternManager.tryingToCreateNewPattern)}/>
        <input type="file" style={{display: 'none'}} id="input-pattern" onChange={this.handleLoadPatFile}  accept=".pat"/>
        <div className="workspace">
          <ToolHeader/>
          { 
            (user.isLoggedIn || true) && <ReflexContainer orientation="vertical">
                {
                  (canI(user, team, 'recent_patterns', team.current) && globalReducer.showRecentPatterns) && <ReflexElement onResize={this.incrementResize} size={135} minSize={135} maxSize={135} style={{width: 135}} key={"testkey"}>
                    <div className="pane recent-patterns-pane">
                      <div className="pane-header">
                        <span className="pane-name">
                          Recently Edited
                        </span>
                      </div>
                      { recentPatternsPaneContent }
                    </div>
                  </ReflexElement>
                }
                <ReflexElement onResize={this.incrementResize}>
                  { pattern.mode === 'raster' && editorPane('.PAT Text') }
                  { pattern.mode === 'drawing' && editorPane('Drawing Canvas') }
                  { pattern.mode === 'template' && editorPane('Template') }
                </ReflexElement>
                <ReflexSplitter propagate={true}/>
                {
                  pattern.mode === 'raster' ? 
                  <ReflexElement minSize={33} onResize={this.incrementResize} >
                    { renderPane('.PAT Preview') }
                  </ReflexElement>
                  :
                  <ReflexElement onResize={this.incrementResize}>
                    <ReflexContainer orientation="horizontal">
                      <ReflexElement minSize={33} onResize={this.incrementResize} >
                        { renderPane('.PAT Text') }
                      </ReflexElement>
                      <ReflexSplitter/>
                      <ReflexElement minSize={33} onResize={this.incrementResize} >
                        { renderPane('.PAT Preview') }
                      </ReflexElement>
                    </ReflexContainer>
                  </ReflexElement>
                }
              </ReflexContainer>
            }
          <ToolFooter/>
        </div>
      </div>
    </div>
  }
}


const mapStateToProps = (state) => {
  const { 
    patternManager, globalReducer, user, team
    //...
  } = state;

  return {
    patternManager, globalReducer, user, team
    //...
  }
}

export default connect(mapStateToProps)(Tool);


// WEBPACK FOOTER //
// ./src/routes/Tool.js